import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import ConfigurationBackgroundImage from "./ConfigurationBackgroundImage/ConfigurationBackgroundImage";
import RailConfig from "./RailConfiguration/RailConfig";
import ConfigurationManagementForm from "./ConfigurationManagementForm/ConfigurationManagementForm";
import ScreensaverConfiguration from "./ScreensaverConfiguration/ScreensaverConfiguration";
import HotelChannels from "./HotelChannels/HotelChannels";
import HotelServiceConfiguration from "./HotelServiceConfiguration/HotelServiceConfiguration";
import CustomizeWelcomeScreen from "./CustomizeWelcomeScreen/CustomizeWelcomeScreen";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      // className="tabpanelcustom"
      {...other}
    >
      {value === index && (
        <Box>
          {children}
          {/* <Typography>{children}</Typography> */}
        </Box>
      )}
    </div>
  );
};

function DefaultConfiguration() {
  const [value, setValue] = useState(0);

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      className: `eachtab ${value === index ? "Mui-selected" : ""}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="pt-2 px-3 bg-white rounded-1">
      <div className="left-column-header">
        <p><strong>Default Configuration Screen</strong></p>
      </div>
      <Box className="boxroot disable-tab">
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              hidden: true,
              style: { transition: "none" },
            }}
          >
            <Tab label="Hero Banner" {...a11yProps(0)} />
            <Tab label="Rail Config" {...a11yProps(1)} />
            <Tab label="Background Image" {...a11yProps(2)} />
            <Tab label="Screensaver" {...a11yProps(3)} />
            <Tab label="Hotel Channel" {...a11yProps(4)} />
            <Tab label="Hotel Services" {...a11yProps(5)} />
            <Tab label="Customize Welcome Screen" {...a11yProps(6)} />
          </Tabs>
        </AppBar>

        <TabPanel value={value} index={0}>
          <ConfigurationManagementForm />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <RailConfig />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ConfigurationBackgroundImage />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <ScreensaverConfiguration />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <HotelChannels />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <HotelServiceConfiguration />
        </TabPanel>
        <TabPanel value={value} index={6}>
          <CustomizeWelcomeScreen />
        </TabPanel>
      </Box>
    </div>
  );
}

export default DefaultConfiguration;
